export const termsAndConditions = `
<h1>Kullanım Koşulları</h1>

<p>Bu web sitesi (bundan sonra "Site" olarak anılacaktır) üzerinden sunulan hizmetleri kullanmadan önce lütfen aşağıdaki kullanım koşullarını dikkatlice okuyunuz. Siteye erişim sağladığınızda ve hizmetleri kullandığınızda, bu kullanım koşullarını kabul etmiş sayılırsınız. Bu koşullar, Siteyi kullanırken karşılaşabileceğiniz tüm şartları belirler.</p>

<h2>1. Hizmet Kullanımı</h2>
<p>Siteyi kullanarak, verdiğiniz tüm bilgilerin doğru, güncel ve eksiksiz olduğunu taahhüt edersiniz. Ayrıca, Site üzerinden gerçekleştirilen tüm işlemlerden sorumlu olduğunuzu kabul edersiniz. Web sitesine erişiminiz ve bu platformdaki hizmetlerden faydalanmanız sadece yasal olarak yetkilendirilmiş ve erişim izinlerinizle sınırlıdır.</p>

<h2>2. Hesap Güvenliği</h2>
<p>Siteye üye olan kullanıcıların hesap bilgileri ve şifreleri tamamen kendilerine aittir. Hesap güvenliğinden ve şifrelerin korunmasından kullanıcı sorumludur. Şifrenizi kimseyle paylaşmamalı ve şifrelerinizin güvende olduğundan emin olmalısınız. Şifrenizin kötüye kullanılması durumunda, kullanıcı hesaplarının güvenliğini sağlamak amacıyla derhal yetkili kişilerle iletişime geçmeniz gerekmektedir.</p>

<h2>3. Gizlilik</h2>
<p>Siteyi kullanarak, kişisel verilerinizin gizlilik politikamız ve yasal düzenlemelere uygun olarak işlendiğini kabul edersiniz. Kişisel verileriniz, yalnızca belirtilen amaçlar doğrultusunda kullanılacaktır. Gizlilik politikamızda belirtilen koşullara ve tüm yasalara uyulacaktır.</p>

<h2>4. Fikri Mülkiyet</h2>
<p>Site üzerinde yer alan tüm içerikler, yazılımlar, grafikler, tasarımlar ve diğer materyaller, [Şirket Adı]’nın fikri mülkiyetidir. Bu içerikler, kullanıcıların izni olmadan kopyalanamaz, çoğaltılamaz veya başka bir şekilde kullanılmaz. Kullanıcı, Siteyi yalnızca kişisel kullanım amacıyla ve belirlenen sınırlar çerçevesinde kullanabilir.</p>

<h2>5. Sorumluluk Reddi</h2>
<p>Site üzerinden yapılan işlemler sonucu doğabilecek herhangi bir zarar ve kayıptan [Şirket Adı] sorumlu değildir. Kullanıcılar, tüm faaliyetlerini kendi riskleri altında gerçekleştirirler. Web sitesinde bulunan bilgiler, doğrudan veya dolaylı olarak herhangi bir garanti verilmeksizin sağlanmaktadır.</p>

<h2>6. Değişiklikler</h2>
<p>Bu kullanım koşulları, [Şirket Adı] tarafından herhangi bir önceden bildirim yapılmaksızın değiştirilebilir. Değişiklikler web sitesi üzerinde yayınlandığı tarihten itibaren geçerli olur. Kullanıcılar, değişiklikleri takip etmekle yükümlüdür. Şartların değiştirilmesi durumunda, kullanıcının devam eden kullanımı, yeni koşulları kabul ettiğini gösterir.</p>

<h2>7. Yasal Yükümlülükler</h2>
<p>Siteyi kullanarak, yasalara, düzenlemelere ve ilgili tüm hükümlere uyacağınızı kabul edersiniz. Ayrıca, Siteyi herhangi bir yasadışı faaliyet için kullanamayacağınızı da taahhüt edersiniz.</p>

<h2>8. İletişim</h2>
<p>Herhangi bir sorunuz, şikayetiniz veya geribildiriminiz olduğunda bizimle iletişime geçebilirsiniz. İletişim bilgilerine web sitesinden ulaşabilirsiniz.</p>

`;

export const privacyPolicy = `
<h1>Gizlilik Politikası (KVKK Aydınlatma Metni)</h1>

<p>Bu Gizlilik Politikası, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili yasal düzenlemelere uygun olarak hazırlanmıştır. Kullanıcıların kişisel verilerinin nasıl toplandığı, işlendiği ve korunduğu hakkında bilgi vermek amacıyla düzenlenmiştir.</p>

<h2>1. Veri Sorumlusu</h2>
<p>Kişisel verileriniz, [Şirket Adı] (bundan sonra "Şirket" olarak anılacaktır) tarafından toplanmakta ve işlenmektedir. Şirket, kişisel verilerinizi koruma yükümlülüğü taşır ve verilerinizi yalnızca belirli amaçlarla kullanır. Şirket, kişisel verilerin korunmasından sorumlu veri sorumlusudur.</p>

<h2>2. Kişisel Verilerin İşlenme Amacı</h2>
<p>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
<ul>
    <li>Hizmet sunumu ve kullanıcı taleplerinin yerine getirilmesi.</li>
    <li>Müşteri ilişkileri yönetimi ve kullanıcı deneyiminin iyileştirilmesi.</li>
    <li>Yasal yükümlülüklerin yerine getirilmesi.</li>
    <li>Site üzerinde yapılan işlemlerin doğruluğunun sağlanması ve güvenliğinin temin edilmesi.</li>
    <li>Pazarlama, reklam ve promosyon amacıyla iletişim kurulması (kullanıcı onayı ile).</li>
</ul>

<h2>3. Kişisel Verilerin Aktarımı</h2>
<p>Kişisel verileriniz, yasal zorunluluklar dışında, üçüncü şahıslarla paylaşılmamaktadır. Ancak, kullanıcı verileri, hizmet sağlayıcılar ve iş ortakları ile veri işleme sözleşmeleri kapsamında, yalnızca belirtilen amaçlarla paylaşılabilir.</p>

<h2>4. Veri Güvenliği</h2>
<p>Kişisel verilerinizin güvenliği en yüksek düzeyde korunmaktadır. Şirket, verilerinizin güvenliğini sağlamak amacıyla gerekli teknik ve idari önlemleri alır. Veri güvenliği için kullanılan sistemler düzenli olarak denetlenir ve iyileştirilir.</p>

<h2>5. Kullanıcı Hakları</h2>
<p>6698 sayılı Kişisel Verilerin Korunması Kanunu'nun 11. maddesi uyarınca, kişisel verilerinize ilişkin olarak aşağıdaki haklara sahipsiniz:</p>
<ul>
    <li>Verilerinize erişim hakkı.</li>
    <li>Verilerinizin düzeltilmesi hakkı.</li>
    <li>Verilerinizin silinmesi veya yok edilmesi hakkı.</li>
    <li>Verilerinize itiraz etme hakkı.</li>
    <li>Verilerinizin işlenme amacının sona erdiğinde silinmesi talebi.</li>
</ul>
<p>Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.</p>

<h2>6. İletişim</h2>
<p>Kişisel verilerinizi nasıl işlediğimizle ilgili herhangi bir sorunuz veya talebiniz olduğunda, aşağıdaki iletişim kanallarından bizimle iletişime geçebilirsiniz:</p>
<ul>
    <li>Email: [email adresi]</li>
    <li>Telefon: [telefon numarası]</li>
    <li>Adres: [Şirket adresi]</li>
</ul>

<p>Bu Gizlilik Politikası, [tarih] tarihinde güncellenmiştir ve tüm kullanıcılarımıza duyurulmuştur.</p>

`; 